export default "__VITE_ASSET__6807ad2b__"